import { NotesPage } from "@/pages/NotesPage";
import { appRouterPaths } from "@/services/navigation";
import type { RouteProps } from "react-router-dom";

export const notesPageRoute: RouteProps = {
  path: appRouterPaths.notes,
  element: <NotesPage />,
};
